import { Colors } from '../../consts/Colors.js';
import { A2Data } from '../../consts/Data.js';

export default class SliderA2 extends Phaser.GameObjects.Container {
    constructor(scene, parent) {
        super(scene, 736, 409, []);
        scene.add.existing(this);
        this.scene = scene;
        this.parent = parent;
        this.allTextContents = A2Data.sliderCtnt

        this.scene.addSounds()

        this.img0 = this.scene.add.image(427, 387, 'slider0').setOrigin(0.5)
        this.img1 = this.scene.add.image(358, 387, 'slider1').setOrigin(0.5).setAlpha(0)
        this.ctnt1 = this.scene.createTextElement(this.allTextContents[0].ctntX - 736, this.allTextContents[0].ctntY - 409, this.allTextContents[0]).setAlpha(0)
        this.img2 = this.scene.add.image(119, 255, 'slider2').setOrigin(0).setAlpha(0)
        this.ctnt2 = this.scene.createTextElement(this.allTextContents[1].ctntX - 736, this.allTextContents[1].ctntY - 409, this.allTextContents[1]).setAlpha(0)
        this.img3 = this.scene.add.image(322, 249, 'slider3').setOrigin(0.5).setAlpha(0)
        this.ctnt3 = this.scene.createTextElement(this.allTextContents[2].ctntX - 736, this.allTextContents[2].ctntY - 409, this.allTextContents[2]).setAlpha(0)
        this.img4 = this.scene.add.image(375, 201, 'slider4').setOrigin(0.5).setAlpha(0)
        this.ctnt4 = this.scene.createTextElement(this.allTextContents[3].ctntX - 736, this.allTextContents[3].ctntY - 409, this.allTextContents[3]).setAlpha(0)
        this.img5 = this.scene.add.image(422, 176, 'slider5').setOrigin(0.5).setAlpha(0)
        this.ctnt5 = this.scene.createTextElement(this.allTextContents[4].ctntX - 736, this.allTextContents[4].ctntY - 409, this.allTextContents[4]).setAlpha(0)
        this.img6 = this.scene.add.image(471, 217, 'slider6').setOrigin(0.5).setAlpha(0)
        this.ctnt6 = this.scene.createTextElement(this.allTextContents[5].ctntX - 736, this.allTextContents[5].ctntY - 409, this.allTextContents[5]).setAlpha(0)
        this.img7 = this.scene.add.image(514, 272, 'slider7').setOrigin(0.5).setAlpha(0)
        this.ctnt7 = this.scene.createTextElement(this.allTextContents[6].ctntX - 736, this.allTextContents[6].ctntY - 409, this.allTextContents[6]).setAlpha(0)
        this.img8 = this.scene.add.image(536, 321, 'slider8').setOrigin(0.5).setAlpha(0)
        this.ctnt8 = this.scene.createTextElement(this.allTextContents[7].ctntX - 736, this.allTextContents[7].ctntY - 409, this.allTextContents[7]).setAlpha(0)
        this.img9 = this.scene.add.image(425, 383, 'slider9').setOrigin(0.5).setAlpha(0)

        this.facteursStress = this.scene.add.image(895 - 736, 911 - 409, 'facteursStress').setOrigin(0.5).setAlpha(0)
        this.facteursVulnerabilite = this.scene.add.image(1340 - 736, 911 - 409, 'facteursVulnerabilite').setOrigin(0.5)

        this.allImages = [this.img0, this.img1, this.img2, this.img3, this.img4, this.img5, this.img6, this.img7, this.img8, this.img9]

        // Suivi de l'état des items pour ne jouer le son qu'une seule fois
        this.itemsVisible = [false, false, false, false, false, false, false, false];

        this.sliderBar = this.scene.add.image(90, 580, 'sliderBar').setOrigin(0, 0.5);
        this.sliderButton = this.scene.add.circle(90, 580, 25, Colors.Elmt.MidBlue).setInteractive({ useHandCursor: true }).setAlpha(1)
        this.slider = this.scene.plugins.get('rexSlider').add(this.sliderButton, {
            endPoints: [
                { x: 90, y: 580 },
                { x: 760, y: 580 }
            ],
            value: 0,
            enable: true,
            valuechangeCallback: (value) => {
                if (value > 0.125) {
                    if (!this.itemsVisible[0]) {
                        this.scene.playSound('pop');
                        this.itemsVisible[0] = true;
                    }
                    this.img1.setAlpha(1)
                    this.ctnt1.setAlpha(1)
                    this.facteursStress.setAlpha(1)
                } else if (value <= 0.125) {
                    this.itemsVisible[0] = false;
                    this.img1.setAlpha(0)
                    this.ctnt1.setAlpha(0)
                    this.facteursStress.setAlpha(0)
                }
                if (value > 0.25) {
                    if (!this.itemsVisible[1]) {
                        this.scene.playSound('pop');
                        this.itemsVisible[1] = true;
                    }
                    this.img2.setAlpha(1)
                    this.ctnt2.setAlpha(1)
                } else if (value <= 0.25) {
                    this.itemsVisible[1] = false;
                    this.img2.setAlpha(0)
                    this.ctnt2.setAlpha(0)
                }
                if (value > 0.375) {
                    if (!this.itemsVisible[2]) {
                        this.scene.playSound('pop');
                        this.itemsVisible[2] = true;
                    }
                    this.img3.setAlpha(1)
                    this.ctnt3.setAlpha(1)
                } else if (value <= 0.375) {
                    this.itemsVisible[2] = false;
                    this.img3.setAlpha(0)
                    this.ctnt3.setAlpha(0)
                }
                if (value > 0.5) {
                    if (!this.itemsVisible[3]) {
                        this.scene.playSound('pop');
                        this.itemsVisible[3] = true;
                    }
                    this.img4.setAlpha(1)
                    this.ctnt4.setAlpha(1)
                } else if (value <= 0.5) {
                    this.itemsVisible[3] = false;
                    this.img4.setAlpha(0)
                    this.ctnt4.setAlpha(0)
                }
                if (value > 0.625) {
                    if (!this.itemsVisible[4]) {
                        this.scene.playSound('pop');
                        this.itemsVisible[4] = true;
                    }
                    this.img5.setAlpha(1)
                    this.ctnt5.setAlpha(1)
                } else if (value <= 0.625) {
                    this.itemsVisible[4] = false;
                    this.img5.setAlpha(0)
                    this.ctnt5.setAlpha(0)
                }
                if (value > 0.75) {
                    if (!this.itemsVisible[5]) {
                        this.scene.playSound('pop');
                        this.itemsVisible[5] = true;
                    }
                    this.img6.setAlpha(1)
                    this.ctnt6.setAlpha(1)
                } else if (value <= 0.75) {
                    this.itemsVisible[5] = false;
                    this.img6.setAlpha(0)
                    this.ctnt6.setAlpha(0)
                }
                if (value > 0.875) {
                    if (!this.itemsVisible[6]) {
                        this.scene.playSound('pop');
                        this.itemsVisible[6] = true;
                    }
                    this.img7.setAlpha(1)
                    this.ctnt7.setAlpha(1)
                } else if (value <= 0.875) {
                    this.itemsVisible[6] = false;
                    this.img7.setAlpha(0)
                    this.ctnt7.setAlpha(0)
                }
                if (value > 0.95) {
                    if (!this.itemsVisible[7]) {
                        this.scene.playSound('pop');
                        this.itemsVisible[7] = true;
                    }
                    this.img8.setAlpha(1)
                    this.ctnt8.setAlpha(1)
                } else if (value <= 0.95) {
                    this.itemsVisible[7] = false;
                    this.img8.setAlpha(0)
                    this.ctnt8.setAlpha(0)
                    this.parent.nextBtn?.setAlpha(0)
                }
                if (value === 1) {
                    this.parent.endSlider()
                }
            }
        });
        this.add(this.sliderBar);
        this.add(this.sliderButton);
        this.add(this.img0);
        this.add(this.img1);
        this.add(this.img2);
        this.add(this.img3);
        this.add(this.img4);
        this.add(this.img5);
        this.add(this.img6);
        this.add(this.img7);
        this.add(this.img8);
        this.add(this.img9);
        this.add(this.ctnt1);
        this.add(this.ctnt2);
        this.add(this.ctnt3);
        this.add(this.ctnt4);
        this.add(this.ctnt5);
        this.add(this.ctnt6);
        this.add(this.ctnt7);
        this.add(this.ctnt8);
        this.add(this.facteursStress);
        this.add(this.facteursVulnerabilite);

        // this.scene.tweens.add({
        //     targets: this.sliderButton,
        //     scale: 1.2,
        //     duration: 600,
        //     yoyo: true,
        //     repeat: 5,
        //     ease: 'Sine.easeInOut'
        // })

    }

    finalStep() {
        this.sliderButton.setAlpha(0);
        this.sliderBar.setAlpha(0);
        // this.slider.setAlpha(0);
        this.img0.setAlpha(0);
        this.img9.setAlpha(1);

        // this.scene.screenLevel = 9
        // this.scene.parent.changeScreen(this.scene.screenLevel)

    }

    finalReturn() {
        this.sliderButton.setAlpha(1);
        this.sliderBar.setAlpha(1);
        // this.slider.setAlpha(1);
        this.img0.setAlpha(1);
        this.img9.setAlpha(0);
    }

    restartSlider() {
        this.sliderButton.setPosition(90, 580);
        this.slider.setValue(0);
    }




}

